// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Y0-z","smallCardRow":"Z0-z","largeCardRow":"_0-z","productSearchRow":"a1-z","curatedRow":"b1-z"};